module.exports = __webpack_public_path__ + "img/main-gallery.40d758b8.png";